import React, { FC } from "react";
import { Radio as AntRadio } from "antd";
import { InputField, InputTitle } from "./elements";

type Props = {
  onChange?: (e: any) => void;
  value: string;
  label: string;
  radioItems: JSX.Element;
  disabled?: boolean;
};

const RadioWithLabel: FC<Props> = (props) => {
  const { onChange, value, label, radioItems, disabled } = props;

  return (
    <InputField>
      <InputTitle>{label}</InputTitle>
      <AntRadio.Group
        disabled={disabled || false}
        onChange={onChange}
        value={value}
      >
        {radioItems}
      </AntRadio.Group>
    </InputField>
  );
};

export default RadioWithLabel;
